// extracted by mini-css-extract-plugin
export default {"form":"SetTag_form__MmDGz"};